import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { CoreSelectors } from '@next/core-lib';
import { RootState } from '@next/core-lib/app';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { skipWhile, withLatestFrom, switchMap, map, take } from 'rxjs/operators';

import { getSelectedBarnId, getBarns } from '../store/selectors/setting.selector';

@Injectable({
  providedIn: 'root',
})
export class BarnSelectedGuard {
  private readonly router = inject(Router);
  private readonly store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(CoreSelectors.selectLoading),
      skipWhile((isLoading) => isLoading),
      withLatestFrom(this.store.select(getBarns), this.store.select(getSelectedBarnId)),
      switchMap(([_, barns, barnId]) => [
        !barnId || (!!barns && !!barns.find((b) => b.id === barnId)),
      ]),
      map((canActivate) => (canActivate ? canActivate : this.router.parseUrl('/settings/barn'))),
      take(1),
    );
  }
}
